export const resultArticle = {
	REQUEST: 'RESULT_LIST_REQUEST',
	RECEIVE: 'RESULT_LIST_RECEIVE',
	REQUEST_DIFF_PATH_DATA: 'REQUEST_DIFF_PATH_DATA',
	RECEIVE_DIFF_PATH_DATA: 'RECEIVE_DIFF_PATH_DATA',
};



// WEBPACK FOOTER //
// ./src/constants/widgetResultList.constants.js